import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './en.json';
import gr from './gr.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      gr: { translation: gr },
    },
    fallbackLng: 'gr',
    // Do not set `lng` here — a fixed value + LanguageDetector can flip
    // language after first paint and retrigger data-fetch effects.
    interpolation: {
      escapeValue: false,
    },
    supportedLngs: ['en', 'gr'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
